import React from 'react';

interface Props
{
  value: boolean,
  disabled?: boolean,
  onClick: React.MouseEventHandler,
}

export const Toggle: React.FC<Props> = ({value, disabled, onClick}) =>
{
  let onClickHandler:React.MouseEventHandler | undefined = undefined;
  if (!disabled)
  {
    onClickHandler = onClick;
  }
  return (
    <label className="toggle">
      <input type="checkbox" checked={value} disabled={disabled} readOnly={true} />
      <span className="slider" onClick={onClickHandler} />
    </label>
  );
}